import {
    addingHolidayZone,
    addingWeekdayZone,
    addingConsecutiveDaysWorkedZone,
    addingDifferencialDailyZone,
    addingDifferencialWeekendlyZone,
    updatingHolidayZone,
    updatingWeekdayZone,
    updatingConsecutiveDaysWorkedZone,
    updatingDifferencialDailyZone,
    updatingDifferencialWeekendlyZone,
} from 'utils/Zones';

const createZone = async (type, generalData, sectionData) => {
    const apiCalls = {
        'holiday': () => addingHolidayZone(
            generalData.name,
            generalData.description,
            generalData.type,
            generalData.requiredApproval,
            sectionData.selectedHolidays.map(holiday => holiday.id),
            sectionData.definedBy,
            sectionData.deductedTime,
            sectionData.hoursWorkedBelongTo
        ),
        'week_days': () => addingWeekdayZone(
            generalData.name,
            generalData.description,
            generalData.type,
            generalData.requiredApproval,
            sectionData.monday,
            sectionData.tuesday,
            sectionData.wednesday,
            sectionData.thursday,
            sectionData.friday,
            sectionData.saturday,
            sectionData.sunday,
            sectionData.zoneApplies
        ),
        'consecutive_days_worked': () => addingConsecutiveDaysWorkedZone(
            generalData.name,
            generalData.description,
            generalData.type,
            generalData.requiredApproval,
            sectionData.dayAmount,
            sectionData.minHours,
            sectionData.minHoursLastDay,
            sectionData.typeConsecutive,
            sectionData.resetTo,
            sectionData.dayNumber,
            sectionData.weekday1,
            sectionData.weekday2,
            sectionData.selectedOvertimeSustitution.map(overtime => overtime.id)
        ),
        'diferential_daily_extend_zone_rule': () => addingDifferencialDailyZone(
            generalData.name,
            generalData.description,
            generalData.type,
            generalData.requiredApproval,
            sectionData.start,
            sectionData.end,
            sectionData.withinZone,
            sectionData.withinTurn,
            sectionData.early,
            sectionData.late,
            sectionData.planned,
            sectionData.basedBy,
            sectionData.beforeStart,
            sectionData.afterStart,
            sectionData.beforeFinish,
            sectionData.afterFinish,
            sectionData.beforeTimeStart,
            sectionData.afterTimeStart,
            sectionData.beforeTimeFinish,
            sectionData.afterTimeFinish
        ),
        'diferential_weekly_extend_daily': () => addingDifferencialWeekendlyZone(
            generalData.name,
            generalData.description,
            generalData.type,
            generalData.requiredApproval,
            sectionData.startWeekly,
            sectionData.endWeekly,
            sectionData.withinZoneWeekly,
            sectionData.withinTurnWeekly,
            sectionData.earlyWeekly,
            sectionData.lateWeekly,
            sectionData.planned,
            sectionData.basedByWeekly,
            sectionData.beforeStartWeekly,
            sectionData.afterStartWeekly,
            sectionData.beforeFinishWeekly,
            sectionData.afterFinishWeekly,
            sectionData.beforeTimeStartWeekly,
            sectionData.afterTimeStartWeekly,
            sectionData.beforeTimeFinishWeekly,
            sectionData.afterTimeFinishWeekly,
            sectionData.weekday1Weekly,
            sectionData.weekday2Weekly
        )
    }
    return await apiCalls[type]()
};

const updateZone = async (id, type, generalData, sectionData) => {
    const apiCalls = {
        'holiday': () => updatingHolidayZone(
            id,
            generalData.name,
            generalData.description,
            generalData.type,
            generalData.requiredApproval,
            sectionData.selectedHolidays.map(holiday => holiday.id),
            sectionData.definedBy,
            sectionData.deductedTime,
            sectionData.hoursWorkedBelongTo
        ),
        'week_days': () => updatingWeekdayZone(
            id,
            generalData.name,
            generalData.description,
            generalData.type,
            generalData.requiredApproval,
            sectionData.monday,
            sectionData.tuesday,
            sectionData.wednesday,
            sectionData.thursday,
            sectionData.friday,
            sectionData.saturday,
            sectionData.sunday,
            sectionData.zoneApplies
        ),
        'consecutive_days_worked': () => updatingConsecutiveDaysWorkedZone(
            id,
            generalData.name,
            generalData.description,
            generalData.type,
            generalData.requiredApproval,
            sectionData.dayAmount,
            sectionData.minHours,
            sectionData.minHoursLastDay,
            sectionData.typeConsecutive,
            sectionData.resetTo,
            sectionData.dayNumber,
            sectionData.weekday1,
            sectionData.weekday2,
            sectionData.selectedOvertimeSustitution.map(overtime => overtime.id)
        ),
        'diferential_daily_extend_zone_rule': () => updatingDifferencialDailyZone(
            id,
            generalData.name,
            generalData.description,
            generalData.type,
            generalData.requiredApproval,
            sectionData.start,
            sectionData.end,
            sectionData.withinZone,
            sectionData.withinTurn,
            sectionData.early,
            sectionData.late,
            sectionData.planned,
            sectionData.basedBy,
            sectionData.beforeStart,
            sectionData.afterStart,
            sectionData.beforeFinish,
            sectionData.afterFinish,
            sectionData.beforeTimeStart,
            sectionData.afterTimeStart,
            sectionData.beforeTimeFinish,
            sectionData.afterTimeFinish
        ),
        'diferential_weekly_extend_daily': () => updatingDifferencialWeekendlyZone(
            id,
            generalData.name,
            generalData.description,
            generalData.type,
            generalData.requiredApproval,
            sectionData.startWeekly,
            sectionData.endWeekly,
            sectionData.withinZoneWeekly,
            sectionData.withinTurnWeekly,
            sectionData.earlyWeekly,
            sectionData.lateWeekly,
            sectionData.planned,
            sectionData.basedByWeekly,
            sectionData.beforeStartWeekly,
            sectionData.afterStartWeekly,
            sectionData.beforeFinishWeekly,
            sectionData.afterFinishWeekly,
            sectionData.beforeTimeStartWeekly,
            sectionData.afterTimeStartWeekly,
            sectionData.beforeTimeFinishWeekly,
            sectionData.afterTimeFinishWeekly,
            sectionData.weekday1Weekly,
            sectionData.weekday2Weekly
        )
    }
    return await apiCalls[type]();
};

const getSectionByType = (type) => {
    const sectionMap = {
        'holiday': 'holiday',
        'week_days': 'weekDays',
        'consecutive_days_worked': 'consecutiveDays',
        'diferential_daily_extend_zone_rule': 'diferentialDaily',
        'diferential_weekly_extend_daily': 'diferentialWeekly'
    };
    return sectionMap[type];
}

export {
    createZone,
    updateZone,

    getSectionByType
}